/* ==========================================================================
   SPECGT Flexible Media Hero (Phase 2)
   --------------------------------------------------------------------------
   Vanilla JS. No library, no dependencies, unminified.

   This file exists for exactly one reason: CSS cannot stop a video from
   autoplaying, so honouring prefers-reduced-motion for background video
   requires script. Everything else in the hero -- media, heading, copy and
   both CTAs -- is server-rendered Liquid and works with JavaScript disabled.

   Lifecycle follows the pattern established in Phase 1: one AbortController
   per instance, so destroy() removes every listener at once and
   shopify:section:load can never double-bind.
   ========================================================================== */

(function () {
  'use strict';

  var REDUCE = '(prefers-reduced-motion: reduce)';
  var instances = new WeakMap();

  function createHero(root) {
    if (!root || instances.has(root)) return null;

    var controller = new AbortController();
    var signal = controller.signal;
    var reduce = window.matchMedia(REDUCE);
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-specgt-hero-video]'));

    function applyMotionPreference() {
      var shouldPause = reduce.matches;
      videos.forEach(function (video) {
        if (shouldPause) {
          // Marking before pausing lets CSS reveal the poster underneath
          // without a frame of the video showing through.
          video.setAttribute('data-specgt-paused', 'true');
          video.removeAttribute('autoplay');
          try { video.pause(); } catch (e) { /* playback may not have begun */ }
        } else {
          video.removeAttribute('data-specgt-paused');
          var attempt = video.play();
          // Browsers reject autoplay in some contexts; the poster remains,
          // so a rejection is a non-event rather than an error to surface.
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(function () {});
          }
        }
      });
    }

    applyMotionPreference();

    // Honour a preference changed mid-session without needing a reload.
    reduce.addEventListener('change', applyMotionPreference, { signal: signal });

    var instance = {
      destroy: function () {
        controller.abort();
        videos.forEach(function (video) {
          try { video.pause(); } catch (e) { /* no-op */ }
        });
        instances.delete(root);
      }
    };

    instances.set(root, instance);
    return instance;
  }

  function initAll(scope) {
    var container = scope || document;
    if (container.matches && container.matches('[data-specgt-hero]')) {
      createHero(container);
    }
    Array.prototype.forEach.call(
      container.querySelectorAll('[data-specgt-hero]'),
      createHero
    );
  }

  function destroyIn(scope) {
    if (!scope || !scope.querySelectorAll) return;
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-specgt-hero]'),
      function (root) {
        var existing = instances.get(root);
        if (existing) existing.destroy();
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });
})();
